export default __webpack_public_path__ + "static/media/toptier.eed85e66.jpg";